import { defineStore } from 'pinia';
import { ref } from 'vue';
import MemberService from "../services/member-service";

export const useMemberAccountBalanceStore = defineStore('memberAccountBalance', () => {
  const accountBalance = ref<string>("");
  const accountPoints = ref<number>(0);

  async function refreshAccountBalance() {
    try {
      const response = await MemberService.getMemberPointsBalance();
      if (response?.isSuccess) {
        accountBalance.value = response.memberPointsBalance?.totalStringValue ?? "";
        const rawPoints = response.memberPointsBalance?.total ?? response.memberPointsBalance?.points;
        const numericPoints = Number(rawPoints);
        accountPoints.value = Number.isFinite(numericPoints) ? numericPoints : 0;
      }
    } catch (err) {
      console.error("Failed to load member point balance", err);
    }
  }

  function setAccountBalance(balance: string) {
    accountBalance.value = balance;
  }

  return {
    accountBalance,
    accountPoints,
    refreshAccountBalance,
    setAccountBalance,
  };
});
